import { MeUser } from "../../../../../services/models/me-user";
import { InterviewsService } from "../../../../../services/interviews.service";
import { TextCol } from "../../../../records/models/columns/text-col";
import { IQuestion, isSection } from "../../../../../interface/filters";
import { INTERVIEW_SUMMARY_COLUMNS_DEFAULT } from "./interview-summary-table-default-columns";
import { INTERVIEW_SUMMARY_COLUMNS_ELASTIC } from "./interview-summary-table-elastic-columns";
import { INTERVIEW_SUMMARY_COLUMNS_ELASTIC_SHOPPER } from "./interview-summary-table-elastic-columns-shopper";
import { INTERVIEW_ONLINEREP_COLUMNS_DEFAULT } from "./interview-onlinerep-default-columns";
import { InterviewsV2Service } from "src/app/services/interviews-v2.service";
import { INTERVIEW_SUMMARY_COLUMNS_ELASTIC_SHOPPER_MASE } from "./interview-summary-table-elastic-columns-shopper-mase";
import { INTERVIEW_SUMMARY_COLUMNS_PLATFORM } from "./interview-summary-table-platform-columns";


let accessWithOnlineRep: boolean = false;


export const getColumns = (user: MeUser, question: IQuestion, service: InterviewsService | InterviewsV2Service, isSolOrDelivery: boolean) => {

	accessWithOnlineRep = false;
	if (question.section.includes('ONLINEREP')) {
		accessWithOnlineRep = true;
	}
	if (accessWithOnlineRep) {
		return INTERVIEW_ONLINEREP_COLUMNS_DEFAULT(user, service);
	}

	if (isSection(question, "CECCLAIM", "CECRFI")) {
		return service.router?.url === "/interviewSummary/interview-summary-elastic"
			? INTERVIEW_SUMMARY_COLUMNS_ELASTIC(user, service, question)
			: INTERVIEW_SUMMARY_COLUMNS_DEFAULT(user, service, question);
	}

	if (isSection(question, "SHOPPER")) {
		return user.pathbrand === 'b_MASE'
			? INTERVIEW_SUMMARY_COLUMNS_ELASTIC_SHOPPER_MASE(user, service, question)
			: INTERVIEW_SUMMARY_COLUMNS_ELASTIC_SHOPPER(user, service, question);
	}

	return INTERVIEW_SUMMARY_COLUMNS_PLATFORM(user, service, question);
}

// helpers
export const createOptionalSimpleColumn = (condition: boolean, columnName: string): TextCol<any>[] => condition ? [new TextCol(columnName)] : []
